import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi, RequestStrategyEnum, type GetCardsResponse } from '@shared/api';

interface UseCardsStore {
  data: GetCardsResponse[];
  loading: boolean;
  error: string | null;
  getCards: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCardsStore = create<UseCardsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getCards: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.getCards(signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
